export default __webpack_public_path__ + "static/media/calculate.6ad516d8.svg";